import { render } from "./create-person.vue?vue&type=template&id=4e835e2d"
import script from "./create-person.vue?vue&type=script&lang=js"
export * from "./create-person.vue?vue&type=script&lang=js"

import "./create-person.vue?vue&type=style&index=0&id=4e835e2d&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__